module.exports = __webpack_public_path__ + "img/controlador_de_temperatura.a47b2cd8.jpg";